import React, {Fragment, useState, useRef} from 'react';
import EditIcon from '@material-ui/icons/Edit';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { Field, Form } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import AddressSection from '../../../../../../../components/FormSections/Fields/AddressSection'
import CustomFieldsSection from '../../../../../../../components/FormSections/Fields/CustomFieldsSection';
import ExtraUrlsSection from '../../../../../../../components/FormSections/Fields/ExtraUrlsSection';
import PhoneSection from '../../../../../../../components/FormSections/Fields/PhoneSection';
import {PhoneInput, Popup, Select, Radio, Date_picker, Text, MultipleSelect, Accordion} from '../../../../../../../components';
import ForwardIcon from '@material-ui/icons/Forward';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AddIcon from '@material-ui/icons/Add';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InfoIcon from '@material-ui/icons/Info';
import ImageIcon from '@material-ui/icons/Image';
import CancelIcon from '@material-ui/icons/Cancel';
import PhoneIcon from '@material-ui/icons/Phone';
import DeleteIcon from '@material-ui/icons/Delete';


export default function Contact_popup_form(props){
  const[error, setError]=useState({});
  const[new_phone_index, setNewPhoneIndex]=useState(0);
  const[prl_phone_block_popup, setPrlPhoneBlockPopup]=useState(false);
  const[open_section, setOpenSection]=useState('');
  let initial_values=useRef();

  function onSubmit(params){
    params=JSON.parse(JSON.stringify(params));
    //let custom_fields=[];
    //for(let key in params){
    //  if(key.includes('cus_field_')){for(let val of params[key]){custom_fields.push({id:key.replace('cus_field_', ''), value:val});} delete params[key]}
    //}

    //if(window.location.href.includes('app.prospectsafari.com')){params['custom_fields']=custom_fields;}
    delete params.pivot;
    if(params.pivot_x!=undefined){delete params.pivot_x;}
    if(params.companies!=undefined){delete params.companies;}
    if(params.contact_urls!=undefined){
      let new_contact_urls=[];
      for(let cu of params.contact_urls){
        if(cu.url!=''){new_contact_urls.push(cu.url);}
      }
      params.contact_urls=new_contact_urls;
    }
    //DO NOT FORCE THE PLUS ON AT THIS POINT. WILL RESULT IN UNWANTED FORMATTING
    if(params.id==undefined){
        let create=false; for(let key in params){if(params[key]!=undefined && params[key]!='' && key!='company_id'){create=true;}}
        if(create==true){props.createContact(params);}
    }else{
        for(let x of ['first_name', 'last_name', 'email', 'buying_role_id', 'main']){if(params[x]==undefined){params[x]=null}}
        props.updateContact(params.id, params);
    }
    props.handleClose();
  }




  let custom_fields=[];
  if(props.workspace!=undefined){
    for(let wf of props.workspace.workspace_fields){
      if(wf.entity_type=='CONTACT'){
        custom_fields.push(wf);
    }}
  }

  let custom_fields_initial={};
//  if(props.contact!=undefined && props.contact.custom_field_options!=undefined){
//    for(let cdfo of props.contact.custom_field_options){
//      if(custom_fields_initial['cus_field_'+cdfo.custom_deal_field_id]==undefined){
//      custom_fields_initial['cus_field_'+cdfo.custom_deal_field_id]=[cdfo.id]
//    }else{
//      custom_fields_initial['cus_field_'+cdfo.custom_deal_field_id].push(cdfo.id);
//    }
//    }
//  }

 
  console.log(props.contact, 'CONTAACT');
  //DEFAULT WORKING CONTACT TO TRUE ALWAYS WHEN UPDATING.

  if(initial_values.current==undefined || (props.contact!=undefined && initial_values.current.id!=undefined && initial_values.current.id!=props.contact.id)){
    initial_values.current=(props.contact==undefined)?{old_company_id:props.company.id, company_id:props.company.id, contact_urls:[], contact_phone_numbers:[], ...custom_fields_initial, working_contact:true}:
    {original_company_id:props.company.id, company_id:props.company.id, ...props.contact, email:(props.contact.contact_emails[0]==undefined)?null:props.contact.contact_emails[0].email.email, main:props.contact.pivot.main_contact, working_contact:true, buying_role_id:props.contact.pivot.buying_role_id, job_title:props.contact.pivot.job_title, ...custom_fields_initial}}
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_values.current}
      mutators={{
        ...arrayMutators
      }}
      >
      {form_props => (
    <form autocomplete='off' onClick={(e)=>{e.stopPropagation(); e.preventDefault();}} onSubmit={form_props.handleSubmit}>
    <Popup always_open icon={(props.contact==undefined || props.contact.profile_pic==undefined)?undefined:<img src={props.contact.profile_pic} style={{width:'50px', marginLeft:'-10px', marginTop:'-5px'}}/>} title={(props.contact!=undefined)?'prospect_contact_update_popup_title':'prospect_contact_create_popup_title'} handleClose={props.handleClose} align='right' accept_button_click={()=>{console.log('ACCEPTTTTTT'); form_props.form.submit(); form_props.form.reset();}} content={
      <div style={{minHeight:'500px'}}>
      <Grid container style={{marginTop:'20px', marginBottom:'20px', marginLeft:'20px', width:'calc(100% - 40px)'}}>
        <Grid item xs={4}><Text title='First name' name='first_name'/></Grid>
        <Grid item xs={4}><Text title='Last name' name='last_name'/></Grid>
        <Grid item xs={4}/>
        <Grid item xs={4} style={{position:'relative'}}><Field name='email'>{(f)=>(f.input.value=='' && props.company.website!=undefined)?<InfoIcon color='primary' style={{position:'absolute', left:'-15px', top:'15px', cursor:'pointer', width:'18px', height:'18px'}} onClick={()=>{let w=props.company.website; w=w.split('/')[0]; f.input.onChange('info@'+w)}}/>:null}</Field><Text error={(error.email==undefined)?false:true} helperText={error.email} title='Email' name='email'/></Grid>
        <Grid item xs={4} style={{marginTop:'10px'}}><Select title='Buying role' name='buying_role_id' enum="buying_role_id" /></Grid>
        <Grid item xs={4}><Select title='Status' name='status' style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}}  enum='status'/></Grid>
        <Grid item xs={12} style={{marginTop:'5px'}}><Text title='Job title' name='job_title'/></Grid>
        <Field name='main'>{(fmc)=><Grid item xs={(props.contact==undefined || props.contact.pivot.working_contact==false)?12:6}><div style={{marginLeft:'10px'}}><FormControlLabel control={<Field name='working_contact'>{(f)=><Checkbox disabled={fmc.input.value} checked={f.input.value} onClick={(e)=>{let checked=!f.input.value; f.input.onChange(checked);}} name="working_contact" />}</Field>} label={(props.contact==undefined || props.contact.pivot.working_contact==false)?"Working contact (Unsaved change)":"Working contact"} /></div></Grid>}</Field>
        <Field name='working_contact'>{(fwc)=><Grid item xs={6}><div style={{marginLeft:'10px'}}><FormControlLabel control={<Field name='main'>{(f)=><Checkbox checked={f.input.value} onClick={(e)=>{let checked=!f.input.value; f.input.onChange(checked); if(checked){fwc.input.onChange(true);}}} name="main" />}</Field>} label="Main contact" /></div></Grid>}</Field>
        <Field name='email'>{(femail)=>{if(femail.input.value==='' || femail.input.value==undefined){return null;}else{return(<Grid item xs={6}><div style={{marginLeft:'10px'}}><FormControlLabel control={<Field name='unsubscribed_from_email'>{(f)=><Checkbox checked={f.input.value} onClick={(e)=>{let checked=!f.input.value; f.input.onChange(checked);}} name="unsubscribed_from_email" />}</Field>} label="Unsubscribed from email list" /></div></Grid>)}}}</Field>
        <AddressSection {...props} open_section={open_section} setOpenSection={setOpenSection}/>
        {(custom_fields.length>0)?<CustomFieldsSection {...props}  type="CONTACT" open_section={open_section} setOpenSection={setOpenSection}/>:null}
        <ExtraUrlsSection {...props} type="CONTACT" open_section={open_section} setOpenSection={setOpenSection}/>
        <PhoneSection {...props} open_section={open_section} setOpenSection={setOpenSection}/>

      </Grid>
      </div>
    } accept_button={(props.contact!=undefined)?'Update':'Create'}/>
      </form>
    )}</Form>
  );
}

//<Fragment>{custom_fields.map(function(cf){
//  let sd=[]; for(let so of cf.custom_deal_field_options){if(so.deleted_at==null){sd.push(so);}}
//  return(<Grid item xs={6}><Field name={'cus_field_'+cf.id}>{(f)=><MultipleSelect size='small' variant='outlined' with_id title={cf.name} value={f.input.value} onChange={f.input.onChange} name={'cus_field_'+cf.id} select_data={sd}/>}</Field></Grid>)
//})}</Fragment>
